export enum ContextEnum {
  Report = 'Relatório',
  Dnc = 'DNC',
  Bpa = 'BPA',
}
